import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { formDetails as getFormDetails } from '../utils/urls';

import { Forms } from 'types/forms';
import { ErrorModal } from 'types/modalTypes';

async function fetchFormDetails({
  accountId,
  formId,
}: TVariables): Promise<TResult> {
  const response = await fetch(getFormDetails(accountId, formId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Forms | undefined;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: number;
  formId: number;
};

function useGetFormDetails(
  accountId: number,
  formId?: number,
): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_form_details', accountId, formId],
    async () => {
      if (formId)
        return await fetchFormDetails({
          accountId,
          formId,
        });
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      enabled: formId !== 0 && accountId !== 0,
    },
  );
}

export { useGetFormDetails };
